// Estado global via Preact signals.

import { signal, computed } from '@preact/signals';
import {
  getEndpoints,
  getActive,
  getUserId,
  getTheme,
  applyTheme,
  getShowSteps,
  getShowReasoning,
  type Endpoint,
  type ActiveRef,
} from '../lib/auth';

export const endpoints = signal<Endpoint[]>(getEndpoints());
export const active = signal<ActiveRef | null>(getActive());

export const activeEndpoint = computed<Endpoint | null>(() => {
  const a = active.value;
  if (!a) return null;
  return endpoints.value.find((e) => e.url === a.endpointUrl) ?? null;
});

export const activeToken = computed<string>(() => activeEndpoint.value?.token ?? '');
export const activeUrl = computed<string>(() => activeEndpoint.value?.url ?? '');
// db_id do alvo ativo (team ou agent), lido do catálogo já cacheado no endpoint
// (`/teams` e `/agents` devolvem `db_id`). As rotas de sessão e memória mandam
// esse valor; sem ele, um AgentOS com vários DBs devolve 400 e a Dalila (DBs
// `dalila` e `dalila-agno`, team grava no segundo) aparecia sem histórico.
// `undefined` quando o alvo não informa — aí o param é omitido.
export const activeDbId = computed<string | undefined>(() => {
  const a = active.value;
  const catalog = activeEndpoint.value?.catalog;
  if (!a || !catalog) return undefined;
  const list = a.isTeam ? catalog.teams : catalog.agents;
  return list.find((t) => t.id === a.targetId)?.db_id || undefined;
});

export const hasActiveTarget = computed<boolean>(() =>
  !!(active.value && activeEndpoint.value && activeToken.value),
);

export const userId = signal<string>(getUserId());
export const theme = signal<'light' | 'dark' | 'auto'>(getTheme());

export const showSteps = signal<boolean>(getShowSteps());
export const showReasoning = signal<boolean>(getShowReasoning());

// UI de shell: drawer da sidebar em mobile (< md). Em desktop a sidebar é
// sempre visível; o flag só governa o overlay em telas pequenas.
export const sidebarOpen = signal<boolean>(false);

applyTheme(theme.value);
const mql = window.matchMedia('(prefers-color-scheme: dark)');
mql.addEventListener('change', () => {
  if (theme.value === 'auto') applyTheme('auto');
});
